﻿/**
 * Mask phone number, if invalid phone number is passed it will return the
 * input back or placeholder if value is undefined or null
 * @param phoneNumber - must be 10 characters long
 * @param fallbackValue - fallback value if phone number is invalid
 * @returns masked phone number in the format of "(123) 456-7890"
 */
export function maskPhoneNumber(phoneNumber: string | undefined | null, fallbackValue = ''): string {
	if (phoneNumber?.length !== 10) {
		return phoneNumber || fallbackValue;
	}

	return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

/**
 * Ensures that the passed value is a valid number. Replaces all characters that are not numbers with an empty string.
 *
 * @param {string} value
 * @return {string}
 */
export function sanitizeNumberValue(value?: string | null) {
	if (!value) return value;

	return value.replace(/[^0-9]/g, '');
}

const capitalize = (str: string): string => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export function formatErrorClassName(errorName: string) {
	return `${capitalize(errorName)}Error`;
}

export function formatGraphQLErrorClassName(errorName: string) {
	return `${capitalize(errorName)}GraphQLError`;
}
